(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plusobject-inquiry-reporting"] && !Shopify.designMode) return;
  try {
    (() => {
  const eventName = 'plusobject:product_inquiry_submitted';
  const maximumAge = 30 * 60 * 1000;
  const initialized = new WeakSet();
  let loadingPrivacy = false;

  function permissionState() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return null;
    try {
      return privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true &&
        privacy.saleOfDataAllowed() === true;
    } catch { return null; }
  }

  function initialize() {
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures && !loadingPrivacy) {
      loadingPrivacy = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (!error) initialize();
      });
    }

    document.querySelectorAll('script[data-po-inquiry-reporting]').forEach(node => {
      if (initialized.has(node)) return;
      initialized.add(node);
      let config;
      try { config = JSON.parse(node.textContent); } catch { return; }
      const form = document.getElementById(config.form_id);
      if (!form || !form.contains(node)) return;
      const storageKey = `po:inquiry:pending:${config.product_id}:${config.form_id}`;
      const discard = () => {
        try { sessionStorage.removeItem(storageKey); } catch {}
      };

      form.addEventListener('submit', () => {
        if (permissionState() !== true || !window.crypto?.randomUUID) {
          discard();
          return;
        }
        let variantId = config.variant_id;
        try {
          const productUrl = form.querySelector('[data-inquiry-url]')?.value;
          const selected = new URL(productUrl, window.location.href).searchParams.get('variant');
          if (/^\d{1,20}$/.test(selected || '')) variantId = selected;
          sessionStorage.setItem(storageKey, JSON.stringify({
            id: window.crypto.randomUUID(),
            created_at: Date.now(),
            product_id: config.product_id,
            variant_id: variantId,
            form_id: config.form_id
          }));
        } catch {}
      });

      document.addEventListener('visitorConsentCollected', () => {
        if (permissionState() !== true) discard();
      });

      function reportSuccess(attempt = 0) {
        if (config.posted_successfully !== true) return;
        const permission = permissionState();
        if (permission === false) {
          discard();
          return;
        }
        if (permission !== true || !window.Shopify?.analytics?.publish) {
          if (attempt < 40) setTimeout(() => reportSuccess(attempt + 1), 200);
          return;
        }
        let pending;
        try { pending = JSON.parse(sessionStorage.getItem(storageKey)); } catch { return; }
        if (!pending) return;
        const age = Date.now() - pending.created_at;
        if (pending.product_id !== config.product_id || pending.form_id !== config.form_id ||
            !/^[a-f\d-]{36}$/i.test(pending.id || '') || !/^\d{1,20}$/.test(pending.variant_id || '') ||
            !Number.isFinite(age) || age < 0 || age > maximumAge) {
          discard();
          return;
        }
        discard();
        const restore = () => {
          try {
            if (!sessionStorage.getItem(storageKey)) sessionStorage.setItem(storageKey, JSON.stringify(pending));
          } catch {}
        };
        try {
          const accepted = window.Shopify.analytics.publish(eventName, {
            inquiry_id: pending.id,
            product_id: config.product_id,
            variant_id: pending.variant_id,
            product_name: String(config.product_name || '').slice(0, 100),
            form_id: config.form_id,
            inquiry_type: 'product'
          });
          Promise.resolve(accepted).then(result => {
            if (result === false) restore();
          }).catch(restore);
        } catch {
          restore();
        }
      }

      reportSuccess();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
